module.exports = __webpack_public_path__ + "img/tech_bg.93f85e3.png";